import React from 'react'
import { Button, Icon, Header } from 'semantic-ui-react'
import { Modal } from 'react-bootstrap'
import ExpertCard from './ExpertCard'
import { getConflictProjectJobs } from './helpers'

const Preview = ({ mergeData, setPage }) => {
    const { sourceUser, targetUser, isSourceClient } = mergeData
    const conflicts = getConflictProjectJobs(sourceUser.jobs, targetUser.jobs)
    const next = () => {
        if (conflicts.length > 0) {
            setPage('JOB_CONFLICTS')
        } else if (isSourceClient) {
            setPage('DELETE_SOURCE')
        } else {
            setPage('CONFIRM')
        }
    }
    return (
        <div>
            <Header as="h4" style={{ marginTop: '1rem' }}>
                {`Merge the data from the account "${sourceUser.email}" into the account "${targetUser.email}"`}
            </Header>
            <ExpertCard user={sourceUser} />
            <Icon
                name="angle double down"
                color="black"
                size="large"
                style={{ marginLeft: '25rem' }}
            />
            <ExpertCard user={targetUser} />
            <Modal.Footer>
                <Button primary content="Next" onClick={next} />
            </Modal.Footer>
        </div>
    )
}

export default Preview
